export default __webpack_public_path__ + "locales/tr/DeleteProfileEverDialog.json?hash=d1395977f36139a6e80bd682e155a82a";